import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const CWelcomeSection = ({ id }) => {
  const [WSList, setWSList] = useState([]);

  const fetchData = async () => {
    try {
      const response = await corefetch(
        `WelcomeSection/GetAboutSectionList?displayesInID=${id}`
      );
      if (response && response.length > 0) {
        setWSList(response);
      } else {
        setWSList([]);
      }
    } catch (error) {
      setWSList([]);
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  if (!WSList || WSList.length == 0) {
    return null;
  }
  return (
    <>
      <section className="about section-padding bg-white" id="AboutUS">
        <div className="container">
          {WSList.map((item, index) => (
            <div className="row" key={index}>
              <div className="col-md-3">
                <div className="sub-title border-bot-light">Welcome to</div>
              </div>

              <div className="col-md-9">
                <div className="section-title">{item.title}</div>

                <div className="row">
                  <div className="col-md-6">
                    <p>{item.description}</p>
                  </div>
                  <div className="col-md-6">
                    <div className="row g-3">
                      <div className="text-center">
                        <img
                          className=" rounded w-75 wow zoomIn event-image"
                          data-wow-delay="0.1s"
                          src={`${ImageURL}${item.imagePath}`}
                          alt={"Event Image"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default CWelcomeSection;
